import { call, put } from 'redux-saga/effects'
import {
  requestAddCommunities,
  requestAddSpeciality,
  requestCommunities,
  requestDoctorInfo,
  requestDoctorList,
  requestDoctorSpecialities,
  requestEditDoctorProfile,
  requestDeleteSpeciality,
  requestDeleteCommunity,
  requestAddExperience,
  requestAddEducation,
  requestDeleteExperience,
  requestDeleteEducation,
  requestUpdateExperience,
  requestUpdateEducation,
  requestVerifyNmc
} from '../requests/doctorServices'
import {
  setLoading,
  setError,
  setSpecialities,
  setDoctorList,
  setDoctorInfo,
  setCommunitiesInfo,
  updateCommunitiesInfo,
  updateDoctorSpecialities,
  removeCommunityFromState,
  removeSpecialityFromState,
  addEducationToState,
  addExperiencesToState,
  removeExperienceFromState,
  removeEducationFromState,
  updateEducationToState,
  updateExperienceToState,
  updateNmcState
} from '../../slices/doctorSlice'
import { toast } from 'react-toastify'

function* handleSpecialitiesGet() {
  try {
    yield put(setLoading({type:"specialization"}))
    const response = yield call(() => requestDoctorSpecialities())
    yield put(setSpecialities(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({error:errorMsg, type:"specialization"}))
  }
}

function* handleDoctorSearch(action) {
  try {
    yield put(setLoading({type:"doctor"}))
    const response = yield call(() => requestDoctorList(action.payload))
    yield put(setDoctorList(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
    yield put(setError({error:errorMsg, type:"doctor"}))
  }
}

function* handleDoctorInfoGet(action) {
  try {
    yield put(setLoading({type: "info"}))
    const response = yield call(() => requestDoctorInfo(action.payload))
    yield put(setDoctorInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
    yield put(setError({error:errorMsg, type:'info'}))
  }
}

function* handleCommunitiesGet() {
  try {
    yield put(setLoading({type:"community"}))
    const response = yield call(() => requestCommunities())
    yield put(setCommunitiesInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({error:errorMsg, type:"community"})) }
}

function* handleEditDoctorProfile(action) {
  try {
    yield put(setLoading(true))
    const response = yield call(() => requestEditDoctorProfile(action.payload))
    yield put(setDoctorInfo(response.data))
    toast.success("Doctor profile updated")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleAddSpecializationSet(action) {
  try {
    yield put(setLoading(true))
    const response = yield call(() => requestAddSpeciality(action.payload))
    yield put(updateDoctorSpecialities(response.data))
    toast.success("Doctor speciality added")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleAddCommunities(action) {
  try {
    yield put(setLoading(true))
    const response = yield call(() => requestAddCommunities(action.payload))
    toast.success("Doctor Communities Added")
    yield put(updateCommunitiesInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleDeleteCommunity(action) {
  try {
    yield put(setLoading(true))
    yield call(() => requestDeleteCommunity(action.payload))
    toast.success("Doctor community deleted")
    yield put(removeCommunityFromState(action.payload.communityId))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleDeleteSpeciality(action) {
  try {
    yield put(setLoading(true))
    yield call(() => requestDeleteSpeciality(action.payload))
    toast.success("Doctor Speciality Deleted")
    yield put(removeSpecialityFromState(action.payload.specialityId))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleAddExperience(action) {
  try {
    yield put(setLoading(true))
    const response = yield call(() => requestAddExperience(action.payload))
    toast.success("Doctor experience added")
    yield put(addExperiencesToState(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleAddEducation(action) {
  try {
    yield put(setLoading(true))
    const response = yield call(() => requestAddEducation(action.payload))
    toast.success("Doctor education added")
    yield put(addEducationToState(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleDeleteEducation(action) {
  try {
    yield put(setLoading(true))
    yield call(() => requestDeleteEducation(action.payload))
    toast.success("Education deleted")
    yield put(removeEducationFromState(action.payload.educationId))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}


function* handleDeleteExperience(action) {
  try {
    yield put(setLoading(true))
    yield call(() => requestDeleteExperience(action.payload))
    toast.success("Experience deleted")
    yield put(removeExperienceFromState(action.payload.experienceId))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleUpdateEducation(action){
  try{
    yield put(setLoading(true))
    const response = yield call(() => requestUpdateEducation(action.payload))
    yield put(updateEducationToState(response.data))
    toast.success("Doctor education updated")
  }catch(e){
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleUpdateExperience(action){
  try{
    yield put(setLoading(true))
    const response = yield call(() => requestUpdateExperience(action.payload))
    yield put(updateExperienceToState(response.data))
    toast.success("Doctor experience updated")
  }catch(e){
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

function* handleVerifyNmc(action){
  try{
    yield put(setLoading(true))
    const response = yield call(() => requestVerifyNmc(action.payload))
    yield put(updateNmcState({
        index:action?.payload?.index,
        data:response.data
      }))
    toast.success("Doctor NMC Verified")
  }catch(e){
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  }
}

export {
  handleSpecialitiesGet,
  handleDoctorSearch,
  handleDoctorInfoGet,
  handleCommunitiesGet,
  handleEditDoctorProfile,
  handleAddSpecializationSet,
  handleAddCommunities,
  handleDeleteSpeciality,
  handleDeleteCommunity,
  handleAddExperience,
  handleAddEducation,
  handleDeleteExperience,
  handleDeleteEducation,
  handleUpdateEducation,
  handleUpdateExperience,
  handleVerifyNmc
}
